
/* !!! This is code generated by Prisma. Do not edit directly. !!! */
/* eslint-disable */
// biome-ignore-all lint: generated file
// @ts-nocheck 
/*
 * This file should be your main import to use Prisma. Through it you get access to all the models, enums, and input types.
 * If you're looking for something you can import in the client-side of your application, please refer to the `browser.ts` file instead.
 *
 * 🟢 You can import this file directly.
 */

import * as process from 'node:process'
import * as path from 'node:path'
import { fileURLToPath } from 'node:url'
globalThis['__dirname'] = path.dirname(fileURLToPath(import.meta.url))

import * as runtime from "@prisma/client/runtime/client"
import * as $Enums from "./enums"
import * as $Class from "./internal/class"
import * as Prisma from "./internal/prismaNamespace"

export * as $Enums from './enums'
export * from "./enums"
/**
 * ## Prisma Client
 * 
 * Type-safe database client for TypeScript
 * @example
 * ```
 * const prisma = new PrismaClient({
 *   adapter: new PrismaPg({ connectionString: process.env.DATABASE_URL })
 * })
 * // Fetch zero or more Users
 * const users = await prisma.user.findMany()
 * ```
 * 
 * Read more in our [docs](https://pris.ly/d/client).
 */
export const PrismaClient = $Class.getPrismaClientClass()
export type PrismaClient<LogOpts extends Prisma.LogLevel = never, OmitOpts extends Prisma.PrismaClientOptions["omit"] = Prisma.PrismaClientOptions["omit"], ExtArgs extends runtime.Types.Extensions.InternalArgs = runtime.Types.Extensions.DefaultArgs> = $Class.PrismaClient<LogOpts, OmitOpts, ExtArgs>
export { Prisma }

/**
 * Model User
 * 
 */
export type User = Prisma.UserModel
/**
 * Model Session
 * 
 */
export type Session = Prisma.SessionModel
/**
 * Model Website
 * 
 */
export type Website = Prisma.WebsiteModel
/**
 * Model WebsiteEvent
 * 
 */
export type WebsiteEvent = Prisma.WebsiteEventModel
/**
 * Model EventData
 * 
 */
export type EventData = Prisma.EventDataModel
/**
 * Model SessionData
 * 
 */
export type SessionData = Prisma.SessionDataModel
/**
 * Model Team
 * 
 */
export type Team = Prisma.TeamModel
/**
 * Model TeamUser
 * 
 */
export type TeamUser = Prisma.TeamUserModel
/**
 * Model Report
 * 
 */
export type Report = Prisma.ReportModel
/**
 * Model Segment
 * 
 */
export type Segment = Prisma.SegmentModel
/**
 * Model Revenue
 * 
 */
export type Revenue = Prisma.RevenueModel
/**
 * Model Link
 * 
 */
export type Link = Prisma.LinkModel
/**
 * Model Pixel
 * 
 */
export type Pixel = Prisma.PixelModel
/**
 * Model Board
 * 
 */
export type Board = Prisma.BoardModel
/**
 * Model Share
 * 
 */
export type Share = Prisma.ShareModel
/**
 * Model SessionReplay
 * 
 */
export type SessionReplay = Prisma.SessionReplayModel
/**
 * Model SessionReplaySaved
 * 
 */
export type SessionReplaySaved = Prisma.SessionReplaySavedModel
